import type React from 'react';
import type { ReactNode } from 'react';

import Box from '@mui/material/Box';

import { appScrollContainerProps } from '@/layouts/controllers/ScrollRestoration.constants.ts';
import { RouteContent } from '@/routes/RootLayout.comp.tsx';
import { getAppContentStyles, getAppWrapperStyles } from '@/styles/app.styles.ts';

interface LayoutShellProps {
  /** Transparent chrome for login (OCD-308 bare variant). */
  isLoginView?: boolean;
  /** Left offset for the sidebar (0 on bare layouts). */
  marginLeft?: number;
  sidebar?: ReactNode;
  topBar?: ReactNode;
}

/**
 * Shared shell for AppLayout and BareLayout (OCD-308): page wrapper, scroll
 * container marker (OCD-301), optional chrome slots, and the view-transition
 * main region (OCD-306) around RouteContent.
 */
export const LayoutShell: React.FC<LayoutShellProps> = ({
  isLoginView = false,
  marginLeft = 0,
  sidebar,
  topBar,
}) => (
  <Box sx={getAppWrapperStyles(isLoginView)}>
    {sidebar}
    <Box {...appScrollContainerProps} sx={getAppContentStyles(marginLeft, isLoginView)}>
      {topBar}
      {/* OCD-306: named region crossfades on view transitions; chrome stays static.
          OCD-310: data-vt-candidate-card enables the candidate card shared element experiment;
          removing or clearing this single attribute disables the experiment entirely. */}
      <Box
        component="main"
        data-vt-candidate-card=""
        sx={{ viewTransitionName: 'ocd-view-content' }}
      >
        <RouteContent />
      </Box>
    </Box>
  </Box>
);
